module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-MediumItalic-32bbfbee2adb42ec58ac0b4e53ba0a51.woff";